import React from 'react'
import PropTypes from 'prop-types'
import { Container, VipHeadline, Title, Deal, VipSubHeadline } from './styles'
import { IN_UK } from '../../utils/constants'

const DiscountBanner = ({ max, frame }) => (
  <Container>
    <VipHeadline>BACK-TO-SCHOOL SALE:</VipHeadline>
    <Title>
      {IN_UK && frame
        ? 'Save up to £50 on Frame'
        : IN_UK
        ? '15% Off 15″ Calendar'
        : max
        ? 'Save $100'
        : frame
        ? 'Save up to $60 on Frame'
        : '$70 Off 15" Calendar'}
    </Title>
    {max && <VipSubHeadline>when you buy Calendar Max + 15″ Calendar.</VipSubHeadline>}
    <Deal>
      {max
        ? 'Apply discount via “Add a 15″ Calendar” option below. Price will automatically adjust at checkout. Ends 8/28 at 11:59pm PST or while supplies last.'
        : IN_UK
        ? 'Discount automatically applied at checkout. Ends 02/09 at 11:59pm BST or while supplies last.'
        : 'Discount automatically applied at checkout. Ends 8/28 at 11:59pm PST or while supplies last.'}
    </Deal>
  </Container>
)

export default DiscountBanner

DiscountBanner.propTypes = {
  max: PropTypes.bool,
  frame: PropTypes.bool,
}
